import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CharacteristicsPageComponent} from './characteristics-page/characteristics-page.component';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {EcorealCtSharedModule} from '../shared/shared.module';
import {CharacteristicFieldsetComponent} from './characteristic-fieldset/characteristic-fieldset.component';
import {CharacteristicsHelperService} from "./shared/characteristics.helper.service";
import {MultiSelectModule} from 'primeng/multiselect';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    EcorealCtSharedModule,
    MultiSelectModule
  ],
  declarations: [CharacteristicsPageComponent, CharacteristicFieldsetComponent],
  providers: [CharacteristicsHelperService],
  exports: [CharacteristicFieldsetComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CharacteristicsModule { }
